import types from '../types'
import api from '@/pages/comet/api'
import storage from '@/utils/storage'
import storageKey from '@ca/constants/storageKey'

const state = {
  skillTree: [],
  skillTreeInit: false
}

const getters = {
  skillTree: state => {
    return state.skillTree || []
  }
}

const mutations = {
  [types.CHANGE_SKILLTREE] (state, { skillTree }) {
    state.skillTree = skillTree
  },
  [types.CHANGE_SKILLTREE_STATUS] (state, { status }) {
    state.skillTreeInit = status
  }
}
const actions = {
  getSkillTree ({ commit, state }, forceUpdate) {
    return new Promise((resolve, reject) => {
      api.getSkillTree().then(res => {
        let data = res.data
        if (data.code === 1) {
          let temp = []
          Object.keys(data.data).forEach((key) => {
            temp.push(data.data[key].skill_tree)
          })
          temp = temp.sort((a, b) => a.priority - b.priority)
          storage.set(storageKey.SKILL_TREE, temp)
          commit(types.CHANGE_SKILLTREE, {
            skillTree: temp
          })
          commit(types.CHANGE_SKILLTREE_STATUS, { status: true })
        } else {
          commit(types.CHANGE_SKILLTREE, {
            skillTree: { nodes: [] }
          })
          commit(types.CHANGE_SKILLTREE_STATUS, { status: false })
        }
        resolve(res)
      }, err => {
        commit(types.CHANGE_SKILLTREE, {
          skillTree: { nodes: [] }
        })
        commit(types.CHANGE_SKILLTREE_STATUS, { status: false })
        reject(err)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
